import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { UpdateSurveyQuestionRPC } from "./updateSurveyQuestionRPC";

export class UpdateSurveyQuestionRPCClientImpl extends UpdateSurveyQuestionRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: UpdateSurveyQuestionRPC.Request): Promise<LeoRPCResult<UpdateSurveyQuestionRPC.Response, UpdateSurveyQuestionRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/UpdateSurveyQuestion",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      UpdateSurveyQuestionRPC.ResponseDTO,
      UpdateSurveyQuestionRPC.Errors.ErrorsDTO,
      UpdateSurveyQuestionRPC.Response,
      UpdateSurveyQuestionRPC.Errors.Errors
    >(
      response,
      "survey/UpdateSurveyQuestion",
      UpdateSurveyQuestionRPC.Response.fromDTO,
      UpdateSurveyQuestionRPC.Errors.fromDTO
    );
  }
}
